import { ProductLine } from '../helpers/home_services.helper';
import { apiFetch } from './fetch_helper';
import { AuditEventData } from './schemas/audit_event.request';
import { PostLeadData } from './schemas/lead.request';
import { CreateUserData } from './schemas/user.request';

export const createUser = async (userData: CreateUserData): Promise<void> => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(userData),
  };
  await apiFetch('/api/v1/users', requestOptions);
};

export const postLead = async (leadData: PostLeadData): Promise<void> => {
  const userPublicId = leadData.userPublicId;
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(leadData),
  };
  await apiFetch(`/api/v1/bidding/${userPublicId}/lead`, requestOptions);
};

export const auditEvent = async (
  auditEventData: AuditEventData,
  product: ProductLine
): Promise<void> => {
  await apiFetch(`/api/v1/audit/${product}/lead`, auditEventData);
};
